// https://mantlescan.xyz/address/0x1283C5015B1Fb5616FA3aCb0C18e6879a02869cB
export const CROSS_CHAIN_CONTROLLER = '0x1283C5015B1Fb5616FA3aCb0C18e6879a02869cB';

// IPayloadsControllerCore https://mantlescan.xyz/address/0xF089f77173A3009A98c45f49D547BF714A7B1e01
export const PAYLOADS_CONTROLLER = '0xF089f77173A3009A98c45f49D547BF714A7B1e01';

// https://mantlescan.xyz/address/0x5e06b10B3b9c3E1c0996D2544A35B9839Be02922
export const PC_DATA_HELPER = '0x5e06b10B3b9c3E1c0996D2544A35B9839Be02922';

// https://mantlescan.xyz/address/0xb26670d2800DBB9cfCe2f2660FfDcA48C799c86d
export const GRANULAR_GUARDIAN = '0xb26670d2800DBB9cfCe2f2660FfDcA48C799c86d';

// https://mantlescan.xyz/address/0x14816fC7f443A9C834d30eeA64daD20C4f56fBCD
export const GOVERNANCE_GUARDIAN = '0x14816fC7f443A9C834d30eeA64daD20C4f56fBCD';

// https://mantlescan.xyz/address/0x70884634D0098782592111A2A6B8d223be31CB7b
export const EXECUTOR_LVL_1 = '0x70884634D0098782592111A2A6B8d223be31CB7b';

export const CHAIN_ID = 5000;
